export default __webpack_public_path__ + "static/media/loading.4c55c82f.gif";